// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__Dp9VU"};